import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "popup__title" }, "Supported countries", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "popup__description" }, " This eSIM is compatible in the following countries ", -1)
const _hoisted_3 = { class: "tarif-content" }

import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import { PropType } from "vue";
import { Country } from "@/stores/data";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupCountries',
  props: {
  countries: {
    type: Object as PropType<Country[]>,
    required: true,
  },
  requestedCountries: {
    type: Object as PropType<Country[]>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupTemplate, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.countries, (country, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            style: _normalizeStyle(
          __props.requestedCountries.map((c) => c.iso).includes(country.iso)
            ? 'font-weight: bold'
            : ''
        )
          }, _toDisplayString(`${country.name}${
            __props.countries.length > 1 && index < __props.countries.length - 1 ? ", " : ""
          }`), 5))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})